<template>
  <div v-loading="loading" >
    <slot name="title" >
      <portal-title :mode="mode" ></portal-title>
    </slot>
    <slot name="grid" >
      <portal-grid
         :mode="mode"
         :widgets="widgets.filter(filterWidgets)"
         :verticalCompact="verticalCompact"
         :autoSize="autoSize" >
        <template slot-scope="props" >
          <slot name="widget" :widget="props.widget" :delete="deleteWidget" >
            <portal-widget :widget="props.widget" :mode="mode" @delete="deleteWidget" >
            </portal-widget>
          </slot>
        </template>
      </portal-grid>
    </slot>      
    <div v-show="!disableToolbox" class="toolbox" >
      <transition name="custom-classes-transition"
                  enter-active-class="animated slideInRight"
                  leave-active-class="animated slideOutRight" >
        <span v-show="showToolbox" >
          <slot name="toolbox" :board="board" :reload="load" :addWidget="addWidget" >
            <portal-toolbox
               v-model="mode"
               :board="board"
               :t="t"
               @reload="load"
               @newWidget="addWidget" >
            </portal-toolbox>
          </slot>
        </span>
      </transition>
      <i v-if="showToolbox" class="el-icon-arrow-right action" @click="showToolbox = false" ></i>
      <i v-else class="el-icon-arrow-left action" @click="showToolbox = true" ></i>
    </div>
  </div>
</template>

<style scoped>
 .toolbox {
   position: fixed;
   bottom: 0;
   right: 0;
   margin: 10px;
 }
 .toolbox span {
   display: inline-block;
 }
</style>

<script>
import PortalTitle from './PortalTitle.vue'
import PortalGrid from './PortalGrid.vue'
import PortalWidget from './PortalWidget.vue'
import PortalToolbox from './PortalToolbox.vue'

export default {
  components: {
    PortalTitle: PortalTitle,
    PortalGrid: PortalGrid,
    PortalWidget: PortalWidget,
    PortalToolbox: PortalToolbox
  },
  props: {
    id: {
      required: true
    },
    texts: {
      type: Object,
      default: () => {
        return {
        }
      }
    },
    filterWidgets: {
      type: Function,
      default: () => true
    },
    verticalCompact: {
      type: Boolean,
      default: true
    },
    autoSize: {
      type: Boolean,
      default: true
    },
    disableToolbox: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      t: {
        allowEdit: 'Autoriser l\'édition',
        denyEdit: 'Bloquer l\'édition',
        addWidget: 'Ajouter un widget',
        unarchiveBoard: 'Désarchiver un board',
        archiveBoard: 'Archiver le board',
        deleteBoard: 'Supprimer le board',
        cloneBoard: 'Cloner le board',
        addBoard: 'Ajouter un board',
        addWidgetConfirm: 'Ajouter',
        addWidgetPlaceholder: '- Choisir un widget -',
        unarchiveBoardPlaceholder: '- Choisir un Board à désarchiver -',
        unarchiveBoardConfirm: 'Désarchiver',
        changeGroup: 'Groupe du board',
        changeGroupPlaceholder: '- Choisir un groupe -',
        changeGroupConfirm: 'Changer le groupe'
      },
      mode: 'view',
      i: 0,
      widgets: [],
      loading: true,
      showToolbox: false
    }
  },
  mounted () {
    Object.keys(this.t).forEach(k => {
      if (typeof this.texts[k] === 'string') {
        this.t[k] = this.texts[k]
      }
    })
    this.$store.dispatch('load').then(() => {
      this.$store.commit('setId', this.id ? this.id : null)
      this.$store.dispatch('loadBoard').then(() => {
        this.load()
        this.loading = false
      })
    })
  },
  methods: {
    load () {
      this.boardName = this.board.name
      this.group = this.board.group
      this.widgets.splice(0)
      for (let i = 0; i < this.board.widgets.length; ++i) {
        if (parseInt(this.board.widgets[i].i) > this.i) {
          this.i = parseInt(this.board.widgets[i].i)
        }
        this.widgets.push(Object.assign({}, this.board.widgets[i], {
          id: this.board.widgets[i].id,
          i: this.board.widgets[i].i,
          x: this.board.widgets[i].x,
          y: this.board.widgets[i].y,
          w: this.board.widgets[i].w,
          h: this.board.widgets[i].h,
          widget: this.board.widgets[i].widget,
          options: this.board.widgets[i].options,
          original: this.board.widgets[i],
          props: {
            allowResize: null,
            allowDrag: null,
            dragAllowFrom: null
          }
        }))
      }
    },
    addWidget (widget) {
      widget.i = (++this.i).toString()
      this.$store.dispatch('addWidget', widget).then(() => {
        widget.id = this.board.widgets[this.board.widgets.length - 1].id
        widget.props = {
          allowResize: null,
          allowDrag: null,
          dragAllowFrom: null
        }
        this.widgets.push(widget)
      })
    },
    deleteWidget (widget) {
      this.$store.dispatch('deleteWidget', widget.id).then(() => {
        const index = this.widgets.findIndex(w =>  w.id === widget.id)
        if (index !== -1) {
          this.widgets.splice(index, 1)
        }
      })
    }
  },
  computed: {
    board () {
      return this.$store.state.board
    }
  },
  watch: {
    id (val) {
      this.loading = true
      this.$store.commit('setId', typeof val === 'undefined' ? null : val)
      this.$store.dispatch('loadBoard').then(() => {
        this.load()
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons/src/components/Portal.vue